<!-- eslint-disable vue/no-v-html -->
<template>
    <div>
        <div class="p-5">
            <h2 class="text-header form-section__title">
                <span v-for="(item, index) in $root.t('step5.summary')" :key="index"> {{ item }} <br /> </span>
            </h2>
            <div class="row">
                <div class="card shadow p-5" :class="{ 'col-md-7 ': !print }">
                    <div class="summary">
                        <div class="row g-3 summary-item" style="width: 60%">
                            <div>
                                <div class="summary-item__title">
                                    <span v-for="(item, index) in $root.t('step5.policyNumber')" :key="index">
                                        {{ item }}<br />
                                    </span>
                                </div>
                                <div class="summary-item__description">
                                     {{ $formData.policyNumber }}
                                </div>
                            </div>

                            <div v-if="productName">
                                <div class="summary-item__title">
                                    <span v-for="(item, index) in $root.t('step5.productName')" :key="index">
                                        {{ item }} <br />
                                    </span>
                                </div>
                                <div class="summary-item__description" v-html="productName" />
                            </div>

                            <div v-if="areaName">
                                <div class="summary-item__title">
                                    <span v-for="(item, index) in $root.t('step5.areaOfCover')" :key="index">
                                        {{ item }} <br />
                                    </span>
                                </div>
                                <div class="summary-item__description" v-html="areaName" />
                            </div>

                            <div v-if="areaName">
                                <div class="summary-item__title">
                                    <span v-for="(item, index) in $root.t('step5.levelOfCover')" :key="index">
                                        {{ item }} <br />
                                    </span>
                                </div>
                                <div class="summary-item__description" v-html="levelOfCoverName" />
                            </div>

                            <div v-if="excessName">
                                <div v-if="$formData.policyDetails.policyHolderInsured" class="summary-item__title">
                                    <span v-for="(item, index) in $root.t('step5.excess')" :key="index">
                                        {{ item }} <br />
                                    </span>
                                </div>
                                <div v-else class="summary-item__title">
                                    {{ $t('step5.voluntaryExcess') }}
                                </div>
                                <div class="summary-item__description">
                                    <span v-for="(item, index) in excessName" :key="index">
                                        {{ symbol + ' ' + item }} <br />
                                    </span>
                                </div>
                            </div>

                            <div v-if="!$formData.policyDetails.policyHolderInsured">
                                <div class="summary-item__title">
                                    {{ $t('step5.mandatoryExcess') }}
                                </div>
                                <div v-if="mandatoryExcesses.length > 0">
                                    <div
                                        v-for="mandatoryExcess in mandatoryExcesses"
                                        :key="mandatoryExcess.mandatoryExcessId"
                                        class="summary-item__description"
                                    >
                                        {{ symbol }}{{ mandatoryExcess.mandatoryExcessName }}
                                    </div>
                                </div>
                                <div v-else class="summary-item__description">
                                    {{ $t('step5.notApplicable') }}
                                </div>
                            </div>

                            <div v-if="coInsuranceName !== 'None available'">
                                <div>
                                    <div class="summary-item__title">
                                        <span v-for="(item, index) in $root.t('step5.coInsurance')" :key="index">
                                            {{ item }} <br />
                                        </span>
                                    </div>
                                    <div class="summary-item__description" v-html="coInsuranceName" />
                                </div>

                                <div>
                                    <div class="summary-item__title mt-3">
                                        <span v-for="(item, index) in $root.t('step5.additionalBenefits')" :key="index">
                                            {{ item }}<br />
                                        </span>
                                    </div>
                                    <div v-if="additionalBenefits.length > 0">
                                        <div v-for="benefit in additionalBenefits" :key="benefit">
                                            <div class="summary-item__description">
                                                {{ benefit.benefitName }}
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else class="summary-item__description">
                                        <span v-for="(item, index) in $root.t('step5.noneSelected')" :key="index">
                                            {{ item }} <br />
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div v-else>
                                <div>
                                    <div class="summary-item__title">
                                        <span v-for="(item, index) in $root.t('step5.additionalBenefits')" :key="index">
                                            {{ item }} <br />
                                        </span>
                                    </div>
                                    <div v-if="additionalBenefits.length > 0">
                                        <div v-for="benefit in additionalBenefits" :key="benefit">
                                            <div class="summary-item__description">
                                                {{ benefit.benefitName }}
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else class="summary-item__description">
                                        <span v-for="(item, index) in $root.t('step5.noneSelected')" :key="index">
                                            {{ item }} <br />
                                        </span>
                                    </div>
                                </div>

                                <div class="mt-3">
                                    <div class="summary-item__title">
                                        <span v-for="(item, index) in $root.t('step5.coInsurance')" :key="index">
                                            {{ item }} <br />
                                        </span>
                                    </div>
                                    <div class="summary-item__description">
                                        {{ coInsuranceName }}
                                    </div>
                                </div>
                            </div>

                            <div v-if="underwrittingType" class="summary-item__end">
                                <div class="summary-item__title">
                                    <span v-for="(item, index) in $root.t('step5.underwritingType')" :key="index">
                                        {{ item }} <br />
                                    </span>
                                </div>
                                <div class="summary-item__description" v-html="underwrittingType" />
                            </div>
                        </div>

                        <div v-if="frequencySelected" class="price-table ps-5 summary-item" style="width: 40%">
                            <h3 class="price-table__title">
                                <span v-for="(item, index) in $root.t('step5.pricingTable')" :key="index">
                                    {{ item }} <br />
                                </span>
                            </h3>
                            <div class="price-table__item">
                                <div class="summary-item__title price-table__item-label">
                                    <span v-for="(item, index) in $root.t('step5.premiumWithoutTax')" :key="index">
                                        {{ item }}<br />
                                    </span>
                                </div>
                                <div class="price-table__item-value">
                                    {{ symbol
                                    }}{{
                                        Number(frequencySelected.basePremium).toLocaleString('en-GB', {
                                            minimumFractionDigits: 2,
                                        })
                                    }}
                                </div>
                            </div>
                            <div v-if="!frequencySelected.isVatTheOnlyTaxApplied" class="price-table__item">
                                <div class="summary-item__title price-table__item-label">
                                    <span v-for="(item, index) in $root.t('step5.totalTax')" :key="index">
                                        {{ item }} <br />
                                    </span>
                                </div>
                                <div class="price-table__item-value">
                                    {{ symbol
                                    }}{{
                                        Number(frequencySelected.totalTax).toLocaleString('en-GB', {
                                            minimumFractionDigits: 2,
                                        })
                                    }}
                                </div>
                            </div>
                            <div class="price-table__item">
                                <div class="summary-item__title price-table__item-label">
                                    <span v-for="(item, index) in $root.t('step5.totalSurcharge')" :key="index">
                                        {{ item }} <br />
                                    </span>
                                </div>
                                <div class="price-table__item-value">
                                    {{ symbol
                                    }}{{
                                        Number(frequencySelected.totalPaymentFrequencyAmount).toLocaleString('en-GB', {
                                            minimumFractionDigits: 2,
                                        })
                                    }}
                                </div>
                            </div>
                            <div v-if="Number(frequencySelected.vat) > 0" class="price-table__item">
                                <div class="summary-item__title price-table__item-label">
                                    <span v-for="(item, index) in $root.t('step5.VAT')" :key="index">
                                        {{ item }} <br />
                                    </span>
                                </div>
                                <div class="price-table__item-value">
                                    {{ symbol
                                    }}{{
                                        Number(frequencySelected.annualisedVat).toLocaleString('en-GB', {
                                            minimumFractionDigits: 2,
                                        })
                                    }}
                                </div>
                            </div>
                            <div class="price-table__item">
                                <div class="summary-item__title price-table__item-label">
                                    <span v-for="(item, index) in $root.t('step5.totalPremium')" :key="index">
                                        {{ item }} <br />
                                    </span>
                                </div>
                                <div class="price-table__item-value">
                                    {{ symbol
                                    }}{{
                                        Number((frequencySelected.totalPremiumWithTaxAndVat > 0) ? frequencySelected.totalPremiumWithTaxAndVat : frequencySelected.totalPremium).toLocaleString('en-GB', {
                                            minimumFractionDigits: 2,
                                        })
                                    }}
                                </div>
                            </div>
                            <div class="price-table__item">
                                <div class="summary-item__title price-table__item-label">
                                    <span v-for="(item, index) in $root.t('step5.chosen')" :key="index">
                                        {{ item }} <br />
                                    </span>
                                </div>
                                <div class="price-table__item-value">
                                    {{
                                        frequencySelected.paymentFrequencyName.toLocaleString('en-GB', {
                                            minimumFractionDigits: 2,
                                        })
                                    }}
                                </div>
                            </div>
                            <div v-if="frequencySelected.paymentFrequencyName == 'Annual'" class="price-table__item">
                                <div class="summary-item__title price-table__item-label">
                                    <span v-for="(item, index) in $root.t('step5.annualPayment')" :key="index">
                                        {{ item }}
                                    </span>
                                </div>
                                <div class="price-table__item-value">
                                    {{ symbol
                                    }}{{
                                        Number(getFirstInvoiceAmount()).toLocaleString('en-GB', {
                                            minimumFractionDigits: 2,
                                        })
                                    }}
                                </div>
                            </div>
                            <div v-else class="price-table__item">
                                <div class="summary-item__title price-table__item-label">
                                    <span v-for="(item, index) in $root.t('step5.nonAnnualPayment')" :key="index">
                                        {{ item }}
                                    </span>
                                </div>
                                <div class="price-table__item-value">
                                    {{ symbol
                                    }}{{
                                        Number(getFirstInvoiceAmount()).toLocaleString('en-GB', {
                                            minimumFractionDigits: 2,
                                        })
                                    }}
                                </div>
                                <div class="summary-item__title price-table__item-label">
                                    <span
                                        v-for="(item, index) in $root.t('step5.paymentFrequencyDividedByHeader')"
                                        :key="index"
                                    >
                                        {{ item }}
                                        <strong class="text-dark">{{
                                            frequencySelected.paymentFrequencyDividedBy - 1
                                        }}</strong>
                                    </span>
                                    <span
                                        v-for="(item2, index2) in $root.t('step5.paymentFrequencyDividedByBody')"
                                        :key="index2"
                                    >
                                        {{ item2 }}
                                    </span>
                                </div>
                                <div class="price-table__item-value">
                                    {{ symbol
                                    }}{{
                                        Number(getSecondInvoiceAmount()).toLocaleString('en-GB', {
                                            minimumFractionDigits: 2,
                                        })
                                    }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- checkbox area -->
                <div v-if="!print" class="col-md-5 pt-5 right-panel px-5 d-flex">
                    <div>
                        <div class="summary-checkbox">
                            <div class="summary-checkbox__title">
                                <span v-for="(item, index) in $root.t('step2.IPID')" :key="index">
                                    {{ item }} <br />
                                </span>
                            </div>
                            <div class="summary-checkbox__checkbox">
                                <input
                                    id="checkConfirm"
                                    v-model="checkConfirm"
                                    class="summary-checkbox__checkbox-tick"
                                    type="checkbox"
                                    :value="false"
                                    aria-labelledby="cd-read"
                                    :disabled="paymentAcceptedOrException || isApplyLoading || isPaymentInProcess"
                                />
                                <label id="cb-read" class="summary-checkbox__checkbox-label" for="checkConfirm">
                                    <span v-for="(item, index) in $root.t('step5')" :key="index">
                                        <span class="required" />
                                        {{ item.checkIPID }}
                                        <a :href="IPIDLink" target="_blank">{{ item.IPID }}</a>
                                        <br />
                                    </span>
                                </label>
                            </div>
                            <span v-if="!checkConfirm && showError" class="input-error">{{
                                $t('notify.notCheckError')
                            }}</span>
                        </div>

                        <div class="summary-checkbox">
                            <div class="summary-checkbox__title">
                                <span v-for="(item, index) in $root.t('step5.declarationAndData')" :key="index">
                                    {{ item }} <br />
                                </span>
                            </div>
                            <div class="summary-checkbox__checkbox">
                                <input
                                    id="checkAccepted"
                                    v-model="checkAccepted"
                                    class="summary-checkbox__checkbox-tick"
                                    type="checkbox"
                                    :value="false"
                                    aria-labelledby="cd-term"
                                    :disabled="paymentAcceptedOrException || isApplyLoading || isPaymentInProcess"
                                />
                                <label id="cb-term" class="summary-checkbox__checkbox-label" for="checkAccepted">
                                    <span v-for="(item, index) in $root.t('step5')" :key="index">
                                        <span class="required" />
                                        {{ item.checkDeclaration }}
                                        <a
                                            target="_blank"
                                            href="#"
                                            @click="openDeclarationPage($event, languageOptions[index].locale)"
                                        >
                                            {{ item.declaration }}
                                        </a>
                                        <br />
                                    </span>
                                </label>
                            </div>
                            <div v-if="!checkAccepted && showError" class="input-error">
                                {{ $t('notify.notCheckError') }}
                            </div>
                        </div>

                        <div class="summary-checkbox">
                            <div class="summary-checkbox__checkbox">
                                <input
                                    id="checkTicked"
                                    v-model="checkTicked"
                                    class="summary-checkbox__checkbox-tick"
                                    type="checkbox"
                                    :value="false"
                                    aria-labelledby="cd-read"
                                    :disabled="paymentAcceptedOrException || isApplyLoading || isPaymentInProcess"
                                />
                                <label id="cb-read" class="summary-checkbox__checkbox-label" for="checkTicked">
                                    <span v-for="(item, index) in $root.t('step5')" :key="index">
                                        <span class="required" />
                                        {{ item.customerConsentHeader }}
                                        <!-- <a :href="customerLink" target="_blank">{{ item.customerConsentBody }}</a> -->
                                        <br />
                                    </span>
                                </label>
                            </div>
                            <span v-if="!checkTicked && showError" class="input-error">{{
                                $t('notify.notCheckError')
                            }}</span>
                        </div>
                        <div v-if="isValid" class="mx-auto">
                            <div class="mb-4">
                                <div v-for="(item, index) in $root.t('step5')" :key="index">
                                    <strong>{{ item.verifyDesc }}</strong> <br />

                                    <p :id="`payment-desc_{{ index }}`">{{ item.verifyBuyNowDesc }} <br /></p>
                                </div>
                                <div class="summary-item-control-section">
                                    <button
                                        class="btn-lg btn-primary px-5 w-100 applyButton"
                                        :disabled="!enableBuyNowButton"
                                        aria-labelledby="payment-desc"
                                        @click="buyNow()"
                                    >
                                        {{ $t('common.buyNowBtn') }}
                                    </button>
                                </div>
                                <div class="summary-item-control-section">
                                    <p id="apply-desc">
                                        <span v-for="(item, index) in $root.t('step5.verifyApplyNowDesc')" :key="index">
                                            {{ item }}
                                            <br /><br />
                                        </span>
                                    </p>
                                    <div class="mx-auto">
                                        <button
                                            class="btn-lg btn-primary px-5 w-100 applyButton"
                                            :disabled="!enableApplyButton"
                                            aria-labelledby="apply-desc"
                                            @click="apply('applynow')"
                                        >
                                            {{ $t('common.applyNowBtn') }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <p>
                                    <a
                                        href="//www.securitymetrics.com/site_certificate?id=1835118&tk=7b2e118536a46383343bc0779b99b743"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <img
                                            :src="basePath + 'assets/images/Credit_Card_Safe_blue.2.png'"
                                            alt="SecurityMetrics Credit Card Safe"
                                        />
                                    </a>
                                </p>
                            </div>
                        </div>
                        <div v-else class="mb-3 panel panel-default">
                            <p class="panel-body">
                                <span v-for="(item, index) in $root.t('step5.applyNowDesc')" :key="index">
                                    {{ item }} <br />
                                </span>
                            </p>
                            <div class="mx-auto">
                                <button
                                    class="btn-lg btn-primary px-5 w-100 applyButton"
                                    :disabled="!enableApplyButton"
                                    aria-labelledby="apply-desc"
                                    @click="apply('applynow')"
                                >
                                    {{ $t('common.applyNowBtn') }}
                                </button>
                            </div>
                        </div>
                        <!-- POLICY CERTIFICATE is for testing only. -->
                        <!-- <div class="mx-auto mb-3">
              <button
                id="genPdf"
                class="btn-lg btn-primary px-5 w-100 applyButton"
                @click="generatePdf()"
              >
                POLICY CERTIFICATE
              </button>
            </div> -->
                        <!-- UNDERWRITING RESPONSE is for testing only. -->
                        <!-- <div class="mx-auto mb-3">
              <button
                id="genPdf"
                class="btn-lg btn-primary px-5 w-100 applyButton"
                @click="underwritingResponsePdf(self)"
              >
                UNDERWRITING RESPONSE PDF
              </button>
            </div> -->
                        <!-- <div class="mx-auto mb-3">
              <button
                id="genPdf"
                class="btn-lg btn-primary px-5 w-100 applyButton"
                @click="test()"
              >
                GET INSURER
              </button>
            </div> -->
                    </div>
                </div>
            </div>
        </div>

        <!-- Helper Modal -->
        <AppModal
            v-if="!print"
            :title="helperTitle"
            :content="helperContent"
            :is-open="openHelperModal"
            @onClose="closeModal()"
        />

        <div
            id="keepOpenModal"
            class="modal fade"
            tabindex="-1"
            aria-labelledby="keepOpenModalLabel"
            aria-hidden="true"
            data-bs-keyboard="false"
            data-bs-backdrop="static"
            role="dialog"
        >
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3 class="modal-title fw-bold text-center" style="color: red">
                            Please do not close the browser tab or the browser
                        </h3>
                    </div>
                    <div class="modal-body">
                        <p>
                            We are currently processing your request.
                            <br />
                            <strong style="color: red"
                                >Please do not close the browser tab or the browser until the process is
                                complete.</strong
                            >
                        </p>
                        <p>This may take a few minutes.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getSummaryData, setSessionFormData } from '../../data/formData.js'
import baseApi from '../../api/common/baseApi.js'
import { FILE } from '../../api/common/config.js'
import quoteService from '../../api/services/quoteService.js'
import AppModal from '../shared/Modal.vue'
import helper from '../../utils/helper'
import storage from '../../utils/storage.js'
import { STORAGE } from '../../api/common/config.js'
import fillObject from '../../utils/fillObject.js'

import applyOnlineService from '../../api/services/applyOnlineService.js'
import productDocumentType from '../../api/common/constant/productDocumentType'

import { getFormDataCopy, getFamilyCopy } from '../../utils/initObject.js'
import storageEventKey from '../../api/common/constant/storageEventKey'

import { logger } from '../../utils/logger.js'
import languageOptions from '../../localization/lang/languageOptions'

export default {
    // eslint-disable-next-line vue/no-reserved-component-names
    name: 'Summary',
    components: {
        AppModal,
    },
    props: {
        isValid: {
            type: Boolean,
            required: false,
            default: false,
        },
        print: {
            type: Boolean,
            default: false,
        },
        quoteVerify: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            summary: getSummaryData(this),
            product: this.$formData.product,
            quote: this.$quote,
            certificate: null, // certificate pdf file
            previewForm: null,
            generatedPreviewForm: false,
            documentFiles: [],
            isPaymentSent: false,
            policyNumber: this.$formData.policyNumber,
            frequencySelected: {
                paymentFrequencyName: '',
                paymentFrequencyNameTranslation: '',
                basePremium: 0,
                totalTax: 0,
                totalPremium: 0,
                firstInvoice: 0,
                secondInvoice: 0,
                totalPaymentFrequencyAmount: 0,
                paymentFrequencyDividedBy: 0,
                totalPremiumWithTaxAndVat: 0,
                taxDividedByPaymentFrequencyAmount: 0,
                isVatTheOnlyTaxApplied: false,
                annualisedVat: 0
            },
            checkConfirm: null,
            showError: false,
            checkAccepted: null,
            checkTicked: null,
            paymentAcceptedOrException: this.$state.paymentAcceptedOrException,
            paymentStatus: '',
            paymentMessage: '',
            paymentStatusModal: null,
            helperModel: null,
            helperTitle: '',
            helperContent: '',
            openHelperModal: false,

            // Valid get product documents - just get if not existing
            haveProductDocuments: false,

            basePath: helper.getBaseAssetPath(),

            productDocuments: {},
            IPID: null,
            Tob: null,
            PoW: null,
            customerConsent: null,
            // Handle process submit form
            isPaymentInProcess: false,
            isApplyLoading: false,

            IPIDLink: '',
            customerLink: '',
            logStates: [],

            currentLocale: this.$locale,

            languageOptions: languageOptions,

            keepOpenModal: null,
        }
    },
    computed: {
        enableBuyNowButton() {
            return (
                this.checkConfirm &&
                this.checkAccepted &&
                this.checkTicked &&
                !this.paymentAcceptedOrException &&
                !this.isPaymentInProcess &&
                !this.isApplyLoading
            )
        },
        enableApplyButton() {
            // return true
            return (
                this.checkConfirm &&
                this.checkAccepted &&
                this.checkTicked &&
                !this.paymentAcceptedOrException &&
                !this.$state.isApplyOrPaymentComplete &&
                !this.isApplyLoading &&
                !this.isPaymentInProcess
            )
        },
        productName() {
            return helper.displayDualLanguage(
                this.summary.productSelected.productName,
                this.summary.productSelected.productNameTranslation,
                '<br>',
                this.$locale,
            )
        },
        areaName() {
            return helper.displayDualLanguage(
                this.summary.areaSelected.areaOfCoverName,
                this.summary.areaSelected.areaOfCoverNameTranslation,
                '<br>',
                this.$locale,
            )
        },
        levelOfCoverName() {
            return helper.displayDualLanguage(
                this.summary.levelOfCover.levelOfCoverName,
                this.summary.levelOfCover.levelOfCoverNameTranslation,
                '<br>',
                this.$locale,
            )
        },
        excessName() {
            return helper
                .displayDualLanguage(
                    this.summary.voluntaryExcessSelected.voluntaryExcessName,
                    this.summary.voluntaryExcessSelected.voluntaryExcessNameTranslation,
                    ' - ',
                    this.$locale,
                )
                .split(' - ')
        },
        additionalBenefits() {
            var displayBenefits = []
            this.summary.additionalBenefitsSelected.forEach((benefit) => {
                if (displayBenefits.findIndex((i) => i.benefitName == benefit.benefitName) < 0) {
                    displayBenefits.push(benefit)
                }
            })
            return displayBenefits
        },
        coInsuranceName() {
            return this.summary.coInsuranceSelected.length
                ? this.summary.coInsuranceSelected
                      .map((v) => {
                          return helper.displayDualLanguage(
                              v.coInsureName,
                              v.coInsureNameTranslation,
                              '<br>',
                              this.$locale,
                          )
                      })
                      .join(', ')
                : 'None available'
        },
        underwrittingType() {
            const underwriting = this.summary.productSelected.underwritingTypes.find(
                (e) => e.underwritingTypeId === this.$formData.underwritingTypeId,
            )

            return underwriting
                ? helper.displayDualLanguage(
                      underwriting.underwritingTypeName,
                      underwriting.underwritingTypeNameTranslation,
                      '<br>',
                      this.$locale,
                  )
                : ''
        },
        symbol() {
            let selectedProductCurrency = this.summary.productSelected.currencies.find((v) => v.isSelected === true)
            return selectedProductCurrency.currencySymbol
        },
        mandatoryExcesses() {
            return this.summary.productSelected.mandatoryExcesses ? this.summary.productSelected.mandatoryExcesses : []
        },
        cardHolderName() {
            return this.$formData.policyHolder.details.forename + ' ' + this.$formData.policyHolder.details.surname
        },
        annualPaymentDetail() {
            return {
                policyNumber: this.$formData.policyNumber,
                amount: this.frequencySelected.firstInvoice,
                cardHolderName: this.cardHolderName,
                currency: this.symbol,
                email: this.$formData.policyHolder.contactDetails.emailAddress,
            }
        },
        subscriptionPaymentDetails() {
            return {
                policyNumber: this.$formData.policyNumber,
                policyStartDate: this.$formData.policyDetails.policyStartDate,
                currency: this.symbol,
                totalPremiumWithTax: this.frequencySelected.totalPremium,
                firstPayment: this.frequencySelected.firstInvoice,
                subsequentPayment: this.frequencySelected.secondInvoice,
                paymentFrequencyName: this.frequencySelected.paymentFrequencyName,
                paymentFrequencyNameTranslation: this.frequencySelected.paymentFrequencyNameTranslation,
                cardHolderName: this.cardHolderName,
                email: this.$formData.policyHolder.contactDetails.emailAddress,
            }
        },
    },
    mounted() {
        if (this.$formData.policyDetails.policyStartDate == null)
            this.$formData.policyDetails.policyStartDate = sessionStorage.getItem('selectedDate')

        this.keepOpenModal = new window.bootstrap.Modal(document.getElementById('keepOpenModal'), {})

        if (localStorage.getItem(storageEventKey.MORGAN_PRICE_PAYMENT_IN_PROCESSING) !== null) {
            localStorage.removeItem(storageEventKey.MORGAN_PRICE_PAYMENT_IN_PROCESSING)
        }

        this.isApplyLoading = false
        this.isPaymentInProcess = false

        if (this.paymentAcceptedOrException) {
            this.checkConfirm = true
            this.checkAccepted = true
            this.checkTicked = true
        }

        this.validateForm()
        this.getTotalPrice()

        if (!this.print) {
            this.getProductDocument().then((docs) => {
                for (let i = 0; i < docs.length; i++) {
                    this.productDocuments[docs[i].documentType] = {
                        ...docs[i],
                    }
                }

                try {
                    this.IPIDLink = this.productDocuments.IPID.fileUrl
                } catch (eror) {
                    this.IPIDLink = ''
                }
            })
        }

        window.addEventListener('storage', (event) => {
            if (event.storageArea != localStorage) return
        })

        this.timeOutModal = new window.bootstrap.Modal(document.getElementById('timeOutModal'), {})
    },
    async created() {
        window.addEventListener('storage', this.storageEvent)
        if (sessionStorage.getItem('generatedPolicyNumber') !== '1') {
            window.sessionStorage.setItem('generatedPolicyNumber', '0')

            if (this.$formData.policyDetails.policyStartDate == null)
                this.$formData.policyDetails.policyStartDate = sessionStorage.getItem('selectedDate')            

            if (sessionStorage.getItem('generatedPolicyNumber') === '0'){
                sessionStorage.setItem('generatedPolicyNumber', '1')            
                await this.generatePolicyNumber()
            }            
        }
    },
    destroyed() {
        window.removeEventListener('storage', this.storageEvent)
    },
    methods: {
        async generatePolicyNumber() {
            try {
                let insuranceType = this.$quote.insuranceType,
                    selectedDate = this.$formData.policyDetails.policyStartDate

                if (this.policyNumber == '' || this.policyNumber == null) {
                    this.policyNumber = (
                        await baseApi.get(
                            `api/generatePolicyNumber?insuranceType=${
                                insuranceType.insuranceTypeId || 1
                            }&selectedDate=${selectedDate}`,
                        )
                    ).policyNumber
                    
                    this.$formData.policyNumber = this.policyNumber

                    let formData = storage.getSession('formData')
                    formData.policyNumber = this.policyNumber
                    storage.setSession('formData', formData)
                }
            } catch (e) {
                console.error('generatePolicyNumber error: ', e)
                sessionStorage.setItem('generatedPolicyNumber', '0')
            }
        },

        /**
         * Handle prevent user close app form when which not yet done
         *
         * @param {boolean} enable - default = true
         */
        handlePreventCloseApp(enable = true) {
            if (enable) {
                window.onbeforeunload = function (e) {
                    var dialogText = 'Processing your application. Please do not close the browser/tab.'
                    e.returnValue = dialogText
                    return dialogText
                    // return 'Processing your application. Please do not close the browser/tab.'
                }

                return
            }

            window.onbeforeunload = undefined
        },

        /**
         * Handle event user close tab payment - enable 'buy now' button if payment is not successfully
         */
        handleClosePaymentTab() {
            this.isPaymentInProcess = false
        },

        loadScript(FILE_URL, async = true, type = 'text/javascript') {
            return new Promise((resolve, reject) => {
                try {
                    const scriptEle = document.createElement('script')
                    scriptEle.type = type
                    scriptEle.async = async
                    scriptEle.src = FILE_URL
                    scriptEle.addEventListener('load', (ev) => {
                        resolve({ status: true })
                    })

                    scriptEle.addEventListener('error', (ev) => {
                        reject({
                            status: false,
                            message: `Failed to load the script ${FILE_URL}`,
                        })
                    })

                    document.body.appendChild(scriptEle)
                } catch (error) {
                    reject(error)
                }
            })
        },

        declarationEvent(event) {
            if (localStorage.getItem(event.key) === 'Close' && this.declarationWindow) {
                this.declarationWindow.close()
                localStorage.removeItem(event.key)
                if (this.$state.isSubmitFormProcessing) {
                    this.$state.isSubmitFormProcessing = false
                    storage.setSession(STORAGE.iS_SUBMIT_FORM_PROCESSING, false)
                }
            }
        },

        /**
         * Get product documents by doc type
         */
        async getProductDocument(docType = '') {
            let lang = await applyOnlineService.getLanguageByCountry(
                this.$optionData,
                this.$formData.policyHolder.details.residenceCountryId,
                this.$formData.policyHolder.details.nationalityCountryId,
            )

            let product = this.$formData.product
            let file = await applyOnlineService.getProductDocumentsAsync(
                product.productId,
                product.areaId,
                product.levelOfCoverId,
                this.$formData.policyDetails.policyStartDate,
                lang,
                docType,
                true,
                this.$productDocuments,
            )
            return file
        },

        /**
         * Set product documents for attachments (is saved on storage files)
         */
        setProductDocument(self, docTypes) {
            let docs = []
            const productDocuments = self.productDocuments
            for (let docType of docTypes) {
                if (docType === 'TOBA') {
                    switch (this.summary.productSelected.productName.toLowerCase())
                    {
                        case 'evolution health eu and eea':
                        case 'evolution (uk/gib/iom)':
                        {
                            if (!this.$broker ||
                                this.$broker.brokerCompanyName === 'Direct') {
                                docs.push(productDocuments[docType])
                            }
                            break;
                        }
                        default:
                        {                            
                            break;
                        }                
                    }
                }
                else {
                    docs.push(productDocuments[docType])
                }
            }

            self.documentFiles = [...docs]
        },

        async fillFormDataCopy(summary) {
            let formDataCopy = getFormDataCopy()
            var formDataCurrent = this.$formData.getCurrentFormData()

            //family information
            if (formDataCurrent.familyMembers.length) {
                for (let i = 0; i < formDataCurrent.familyMembers.length; i++) {
                    formDataCopy.familyMembers.push(getFamilyCopy())
                }
            }

            formDataCopy = helper.copy(formDataCurrent, formDataCopy)

            formDataCopy.policyHolder.id = formDataCurrent.id

            formDataCopy.formName = 'Apply Online'
            formDataCopy.insuranceTypeId = this.quote.insuranceType.insuranceTypeId
            formDataCopy.insuranceTypeName = this.quote.insuranceType.insuranceTypeName

            // update PaymentStatus
            formDataCopy.paymentStatus = storage.getSession('payment_status') || ''

            // purpose
            formDataCopy.workflow = storage.getSession('purpose') || ''

            // fillObject.fillInsurerDetails(
            // 	formDataCopy,
            // 	summary.productSelected.productID,
            // 	summary.productSelected.productName,
            // )

            fillObject.fillProduct(formDataCopy.product, summary, this.frequencySelected)
            fillObject.fillSummary(formDataCopy.summary, summary, this.frequencySelected)
            fillObject.fillUnderwritingType(formDataCopy, summary)

            // policy fill data
            fillObject.fillPolicy(
                formDataCopy,
                this.$formData.policyHolder.details,
                this.$optionData,
                true,
                this.$formData.policyDetails.policyHolderInsured,
            )

            if (storage.getSession('policyHolderInsured') == true) {
                await fillObject.fillUnderwritingQuestionsAsync(
                    formDataCopy,
                    summary.productSelected.productID,
                    formDataCopy.underwritingTypeId,
                    this.$locale,
                    formDataCopy.policyDetails.policyStartDate,
                    this.$optionData,
                )
            } else {
                formDataCopy.underwritingQuestionGroups = formDataCopy.underwritingQuestions

                delete formDataCopy.underwritingQuestions
            }

            // change format policy start date
            // formDataCopy.policyDetails.policyStartDate = moment(
            // 	formDataCopy.policyDetails.policyStartDate,
            // 	'D-M-Y',
            // ).format('DD-MM-YYYY')

            // Tax
            formDataCopy.policyHolder.details.isTaxIdentificationRequired =
                this.$formData.policyHolder.details.isTaxEnable

            formDataCopy.policyHolder.details.insuredId = this.$formData.policyHolder.details.insuredId

            fillObject.fillPaymentFrequency(formDataCopy, summary)

            // family fill data
            for (const i in formDataCopy.familyMembers) {
                // formDataCopy.familyMembers.forEach((family) => {
                fillObject.fillPolicy(
                    formDataCopy.familyMembers[i],
                    this.$formData.policyHolder.details,
                    this.$optionData,
                    false,
                    this.$formData.policyDetails.policyHolderInsured,
                )

                await fillObject.fillUnderwritingQuestionsAsync(
                    formDataCopy.familyMembers[i],
                    summary.productSelected.productID,
                    formDataCopy.underwritingTypeId,
                    this.$locale,
                    formDataCopy.policyDetails.policyStartDate,
                    this.$optionData,
                )
            }

            formDataCopy.applyOrPaymentComplete = this.$state.isApplyOrPaymentComplete

            // Set log state into formData json data
            logger.setLog(this.$root.statusStepLogs, this.$formData.currentStep, [...this.logStates])
            formDataCopy.logSteps = this.$root.statusStepLogs
            formDataCopy.userEnvironmentInfo = helper.browserDetect(navigator.userAgent)

            if (formDataCopy.underwritingQuestions) {
                formDataCopy.underwritingQuestionGroups = formDataCopy.underwritingQuestions

                delete formDataCopy.underwritingQuestions
            }

            return formDataCopy
        },

        async setDataDisplayFile(self, liveCustomerServiceSharePointEntry, insurerCompany) {
            const displayFormData = await self.fillFormDataCopy(self.summary)

            helper.changeDateFormat(displayFormData)

            if (liveCustomerServiceSharePointEntry) {
                // let isLive = process.env.NODE_ENV === 'production' ? true : false
                let isLive = liveCustomerServiceSharePointEntry
                displayFormData.isLive = isLive
            }

            if (this.$broker) {
                displayFormData.brokerCompanyId = this.$broker.brokerCompanyId
                displayFormData.brokerCompanyName = this.$broker.brokerCompanyName
                displayFormData.brokerRef = this.$broker.brokerRef
            }

            if (insurerCompany) {
                displayFormData.underwriterId = insurerCompany.underwriterId
                displayFormData.underwriterName = insurerCompany.underwriterName
            }

            // Delete old underwritingQuestions array
            if (displayFormData.underwritingQuestions && displayFormData.underwritingQuestions.length === 0) {
                delete displayFormData.underwritingQuestions
            }

            for (const i in displayFormData.familyMembers) {
                if (
                    displayFormData.familyMembers[i].underwritingQuestions &&
                    displayFormData.familyMembers[i].underwritingQuestions.length === 0
                ) {
                    delete displayFormData.familyMembers[i].underwritingQuestions
                }
            }

            if (displayFormData.insuredPremiumBreakdownByPaymentFrequency) {
                delete displayFormData.insuredPremiumBreakdownByPaymentFrequency
            }

            // add ApplicationTime
            displayFormData.applicationTime = storage.getSession('applicationTime')
            displayFormData.userActivity = storage.getSession('userActivity')

            // add insurerId and insurerCompanyName
            displayFormData.insurerId = storage.getSession('insurerId')
            displayFormData.insurerCompanyName = storage.getSession('insurerCompanyName')

            let formDataDisplay = {
                formDataId: displayFormData.id,
                formData: JSON.stringify(displayFormData, null, '\t'),
                verifyQuoteResponse: JSON.stringify(self.quoteVerify, null, '\t'),
            }

            return formDataDisplay
        },

        async underwritingResponsePdf() {
            const self = this
            let insurerCompany = null
            try {
                insurerCompany = await baseApi.post(`api/getInsurerCompany`, {
                    productSelectedId: self.$formData.product.productId,
                    productSelectedName: self.productName,
                    selectedDate: self.$formData.policyDetails.policyStartDate,
                })
            } catch (error) {
                if (process.env.NODE_ENV === 'production') {
                    appInsights.trackException({
                        exception: error,
                        properties: {
                            Function: 'getInsurerCompany',
                            Description: 'submitFormData calls getInsurerCompany. Call failed for the product.',
                            ProductId: self.$formData.product.productId,
                            ProductName: self.productName,
                            PolicyStartDate: self.$formData.policyDetails.policyStartDate,
                        },
                    })
                }
            }

            await this.setDataDisplayFile(self, false, insurerCompany)
        },

        showPaymentStatusModal() {
            this.openHelperModal = true
        },

        closeModal() {
            this.openHelperModal = false
        },

        storageEvent(event) {
            try {
                let eventOriginDomain = new URL(event.url)
                if (window.location.hostname !== eventOriginDomain.hostname) {
                    return
                }
            } catch (e) {
                console.error('storage event: ', e)
                return
            }

            if (event.key) {
                this.$root.paymentStatus = event.key
                switch (event.key) {
                    //#region  PAYMENT EVENT
                    case storageEventKey.MORGAN_PRICE_PAYMENT_ACCEPTED:
                        // Disable previous button
                        this.$state.isApplyOrPaymentComplete = true
                        storage.setSession(STORAGE.APPLY_PAYMENT_SUCCESS, true)
                        storage.setSession('payment_status', 'MORGAN_PRICE_PAYMENT_ACCEPTED')
                        // Disable the buy now button.
                        this.paymentAcceptedOrException = true
                        storage.setSession(STORAGE.PAYMENT_ACCEPT_EXCEPTION, this.paymentAcceptedOrException)
                        this.$forceUpdate()

                        if (!this.print && !this.$formData.certificateGenerate) {
                            // toast notify: need wait
                            this.$toast.open({
                                message: helper.multiLanguageDisplay(this.$root.t('notify.waitProcessing')),
                                type: 'default',
                            })

                            this.handlePreventCloseApp(true)
                            // get memberCard file, screenshot file, gen pdf, apply
                            this.$emit('getMemberCard', (data) => {
                                this.$memberCard = data
                                this.generatePdf(() => {
                                    this.apply('buynow')
                                })
                            })
                        }
                        // In case of failure customer needs to contact us.
                        // Show PaymentStatus modal.
                        this.helperTitle = helper.multiLanguageDisplay(this.$root.t('popup.paymentSuccessTitle'))
                        this.helperContent = helper.multiLanguageDisplay(this.$root.t('popup.paymentSuccess'))

                        // this.showPaymentStatusModal()
                        localStorage.removeItem(storageEventKey.MORGAN_PRICE_PAYMENT_IN_PROCESSING)
                        break
                    case storageEventKey.MORGAN_PRICE_PAYMENT_CANCELLED:
                        // Show PaymentStatus modal.
                        // this.helperTitle = 'Cancelled'
                        // this.helperContent = 'Your payment was cancelled.'
                        // this.showPaymentStatusModal()
                        this.$state.isSubmitFormProcessing = false
                        storage.setSession(STORAGE.iS_SUBMIT_FORM_PROCESSING, false)
                        storage.setSession('payment_status', 'MORGAN_PRICE_PAYMENT_CANCELLED')
                        this.$forceUpdate()
                        localStorage.removeItem(storageEventKey.MORGAN_PRICE_PAYMENT_IN_PROCESSING)

                        this.keepOpenModal.hide()
                        break
                    case storageEventKey.MORGAN_PRICE_PAYMENT_DECLINED:
                        // Show PaymentStatus modal.
                        storage.setSession('payment_status', 'MORGAN_PRICE_PAYMENT_DECLINED')
                        this.helperTitle = helper.multiLanguageDisplay(this.$root.t('popup.paymentDeclinedTitle'))
                        this.helperContent = helper.multiLanguageDisplay(this.$root.t('popup.paymentDeclined'))
                        this.showPaymentStatusModal()
                        localStorage.removeItem(storageEventKey.MORGAN_PRICE_PAYMENT_IN_PROCESSING)

                        this.keepOpenModal.hide()
                        break
                    case storageEventKey.MORGAN_PRICE_PAYMENT_EXCEPTION:
                        // Disable the buy now button.
                        this.paymentAcceptedOrException = true
                        storage.setSession(STORAGE.PAYMENT_ACCEPT_EXCEPTION, this.paymentAcceptedOrException)
                        storage.setSession('payment_status', 'MORGAN_PRICE_PAYMENT_EXCEPTION')
                        // Send email to info with all details attached.
                        this.sendPaymentExceptionMail(
                            'Payment exception for ' +
                                this.cardHolderName +
                                ' for policy number' +
                                this.$formData.policyNumber,
                            `<p>Dear Team,</p>
				<p>
					This customer has attempted to purchase a policy.
					Barclays has returned an exception saying they are not sure if the Transaction was successful.
					Please check if payment has been received and contact the customer as required.
				</p>`,
                        )
                        // Show PaymentStatus modal.
                        this.helperTitle = helper.multiLanguageDisplay(this.$root.t('popup.paymentExceptionTitle'))
                        this.helperContent = helper.multiLanguageDisplay(this.$root.t('popup.paymentException'))
                        // this.showPaymentStatusModal()
                        localStorage.removeItem(storageEventKey.MORGAN_PRICE_PAYMENT_IN_PROCESSING)
                        break
                    //#endregion

                    // Check for declaration
                    case storageEventKey.DECLARATION_STATE:
                        this.declarationEvent(event)
                        break

                    // Payment tab
                    case storageEventKey.MORGAN_PRICE_PAYMENT_TAB_CLOSE:
                        if (localStorage.getItem(storageEventKey.MORGAN_PRICE_PAYMENT_IN_PROCESSING) === null) {
                            this.$state.isSubmitFormProcessing = false
                            storage.setSession(STORAGE.iS_SUBMIT_FORM_PROCESSING, false)
                            this.handleClosePaymentTab()
                        }
                        break
                    default:
                        break
                }
            }
        },

        openDeclarationPage(e, lang) {
            e.preventDefault()

            let product = this.$formData.product
            let paramQuery = `productId=${product.productId}&areaOfCoverId=${product.areaId}&levelOfCoverId=${product.levelOfCoverId}&policyStartDate=${this.$formData.policyDetails.policyStartDate}&language=${lang}`
            this.declarationWindow = window.open(`${process.env.VUE_APP_BASE_PATH}declaration?${paramQuery}`, '_blank')
        },

        buyNow() {
            const isTimeOut = helper.checkTimeOut(storage.getSession('startTime'), window.appSubmitLimitTime)

            if (this.$state.isApplyOrPaymentComplete === false && isTimeOut) {
                this.timeOutModal.toggle()
                return
            }

            this.keepOpenModal.toggle()

            this.$state.isSubmitFormProcessing = true
            storage.setSession(STORAGE.iS_SUBMIT_FORM_PROCESSING, true)
            this.isPaymentInProcess = true
            this.$forceUpdate()
            // setSessionFormData(this.$formData.getCurrentFormData())
            let apiPath = process.env.VUE_APP_API_URL
            let paymentPage =
                this.frequencySelected.paymentFrequencyName === 'Annual' ? 'payment/onetime' : 'payment/subscription'
            //window.location = apiPath + process.env.VUE_APP_BASE_PATH + paymentPage
            // We need this open in a new page as the Vue app looses state
            // when clicking the back button and the user must be given
            // a chance to try again.
            var paymentDetail =
                this.frequencySelected.paymentFrequencyName === 'Annual'
                    ? this.annualPaymentDetail
                    : this.subscriptionPaymentDetails

            var paymentWindow = window.open(apiPath + process.env.VUE_APP_BASE_PATH + paymentPage, '_blank')

            paymentWindow.sessionStorage.setItem('payment', JSON.stringify(paymentDetail))
        },

        async apply(purpose) {
            const self = this
            storage.setSession('purpose', purpose)

            storage.setSession('endTime', helper.getTimestamps())
            this.$endTime = storage.getSession('endTime')

            let elapsedTime = helper.getElapsedTime(storage.getSession('startTime'), storage.getSession('endTime'))

            const isTimeOut = helper.checkTimeOut(storage.getSession('startTime'), window.appSubmitLimitTime)

            storage.setSession('elapsedTime', elapsedTime)

            if (self.$state.isApplyOrPaymentComplete === false && isTimeOut) {
                this.timeOutModal.toggle()
                return
            }

            if (purpose == 'applynow') this.keepOpenModal.toggle()

            try {
                if (!self.checkConfirm || !self.checkAccepted || !self.checkTicked) {
                    self.showError = true
                    return
                } else {
                    self.showError = false
                }

                if (!self.$state.isSubmitFormProcessing) {
                    self.$state.isSubmitFormProcessing = true
                    storage.setSession(STORAGE.iS_SUBMIT_FORM_PROCESSING, true)
                    self.$forceUpdate()
                }

                // if (purpose && purpose !== 'buynow') {
                self.handlePreventCloseApp(true)
                // }

                // add Processing toast
                self.$toast.open({
                    message: helper.multiLanguageDisplay(self.$root.t('notify.waitProcessing')),
                    type: 'default',
                })

                self.isApplyLoading = true

                await self.generatePreviewForm(async () => {
                    await self.submitFormData(self, purpose)
                    self.$state.isSubmitFormProcessing = false
                    storage.setSession(STORAGE.iS_SUBMIT_FORM_PROCESSING, false)
                    self.$forceUpdate()
                    self.handlePreventCloseApp(false)
                })
            } catch (error) {
                if (process.env.NODE_ENV === 'production') {
                    appInsights.trackException({
                        exception: error,
                        properties: {
                            Function: 'apply',
                            Purpose: purpose,
                            Description: 'Calls generatePreviewForm which calls submitFormData.',
                        },
                    })
                }
                console.error('Apply(): ', error)
                self.$root.generatePreviewForm = false
                self.$state.isApplyOrPaymentComplete = false
                storage.setSession(STORAGE.APPLY_PAYMENT_SUCCESS, false)
            }
        },

        async generateApplicationFormPdfFile() {
            const self = this

            if (self.generatedPreviewForm === true) {
                return
            }

            let body = {
                formData: JSON.parse(JSON.stringify(self.$formData.getCurrentFormData())),
                quote: JSON.parse(JSON.stringify(self.$quote)),
                broker: JSON.parse(JSON.stringify(self.$broker)),
                htmlRaw: self.$root.summaryOuterHtml,
            }

            // ignore false question of policy holder & family
            body.formData.underwritingQuestions = body.formData.underwritingQuestions.filter((q) => q.isAnswer)

            try {
                const response = await baseApi.post(`api/pdf/generateApplyOnlineForm`, body)
                const blob = response
                if (blob && blob.size > 0) {
                    const pdfBase64 = await helper.blob2Base64(blob)

                    if (pdfBase64) {
                        self.generatedPreviewForm = true
                        self.previewForm = {
                            fileName: FILE.PREVIEW_FORM,
                            base64: pdfBase64.split(',')[1],
                            contentType: 'application/octet-stream',
                        }
                    }
                } else {
                    logger.setLogSubmit(self.logStates, 'Get preview form PDF file from API')
                }
            } catch (err) {
                self.$toast.open({
                    message: err.statusText,
                    type: 'error',
                })
                console.error(err)
                // self.$root.generatePreviewForm = false
                if (process.env.NODE_ENV === 'production') {
                    appInsights.trackException({
                        exception: err,
                        properties: {
                            Function: 'generateApplyOnlineForm',
                            Description: 'Generates the apply online form pdf.',
                            Url: `api/pdf/generateApplyOnlineForm`,
                        },
                    })
                }
            }
        },

        /**
         * Generate certificate pdf file
         */
        async generatePdf(callback) {
            const self = this
            if (self.print || self.$formData.certificateGenerate) {
                return
            }

            self.$formData.certificateGenerate = true

            let body = {
                formData: JSON.parse(JSON.stringify(self.$formData.getCurrentFormData())),
                quote: JSON.parse(JSON.stringify(self.$quote)),
                broker: JSON.parse(JSON.stringify(self.$broker)),
            }

            // ignore false question of policy holder & family
            body.formData.underwritingQuestions = body.formData.underwritingQuestions.filter((q) => q.isAnswer)

            try {
                const response = await baseApi.post(`api/pdf/generate`, body)

                const blob = await response
                if (blob && blob.size > 0) {
                    const pdfBase64 = await helper.blob2Base64(blob)

                    // Download certificate - test ONLY
                    // var a = document.createElement('a')
                    // a.href = window.URL.createObjectURL(blob)
                    // a.setAttribute('download', FILE.POLICY_CERTIFICATE)
                    // a.click()

                    if (pdfBase64) {
                        self.certificate = {
                            fileName: FILE.POLICY_CERTIFICATE,
                            base64: pdfBase64.split(',')[1],
                            contentType: 'application/octet-stream',
                        }
                    }
                } else {
                    logger.setLogSubmit(self.logStates, 'Get Certificate PDF file from API')
                    // self.$formData.certificateGenerate = false
                }
            } catch (error) {
                self.$toast.open({
                    message: error.statusText,
                    type: 'error',
                })
                console.error(error)
                logger.setLogSubmit(self.logStates, 'Get Certificate PDF file from API', error)
                if (process.env.NODE_ENV === 'production') {
                    appInsights.trackException({
                        exception: error,
                        properties: {
                            Function: 'generatePdf',
                            Description: 'Generates policy certificate.',
                            Url: `api/pdf/generate`,
                        },
                    })
                }
                // self.$formData.certificateGenerate = false
            }

            self.setProductDocument(self, [productDocumentType.IPID, productDocumentType.ToB, productDocumentType.Toba])

            try {
                await self.sendCustomerMail()
            } catch (error) {
                console.error(error)
                if (process.env.NODE_ENV === 'production') {
                    appInsights.trackException({
                        exception: error,
                        properties: {
                            Function: 'sendCustomerMail',
                            Description: 'Sends an email to the customer with policy certficate.',
                        },
                    })
                }

                logger.setLogSubmit(self.logStates, 'Send Customer Mail', error)
            }

            try {
                // Call apply('buynow')
                callback()
            } catch (error) {
                self.$formData.certificateGenerate = false
                console.error(error)
                if (process.env.NODE_ENV === 'production') {
                    appInsights.trackException({
                        exception: error,
                        properties: {
                            Function:
                                'Submit ApplyOnline data to server after completed generate Certificate PDF and Send mail to Customer',
                            Description: 'Called apply("buynow").',
                        },
                    })
                }
                logger.setLogSubmit(
                    self.logStates,
                    'Submit ApplyOnline data to server after completed generate Certificate PDF and Send mail to Customer',
                    error,
                )
            }
        },

        /**
         * Generate preview pdf form
         */
        async generatePreviewForm(callback) {
            const self = this
            if (self.print || self.$root.generatePreviewForm) {
                return
            }

            self.$root.generatePreviewForm = true

            await self.generateApplicationFormPdfFile()

            self.setProductDocument(self, [productDocumentType.IPID, productDocumentType.ToB, productDocumentType.Toba])

            try {
                // Call submitFormData
                await callback()
            } catch (err) {
                self.$root.generatePreviewForm = false
                self.$toast.open({
                    message: err.statusText,
                    type: 'error',
                })

                console.error(err)

                if (process.env.NODE_ENV === 'production') {
                    appInsights.trackException({
                        exception: err,
                        properties: {
                            Function: 'Submit form data to server after generate certificate PDF file has completed.',
                            Description: 'Called submitFormData.',
                        },
                    })
                }

                logger.setLogSubmit(
                    self.logStates,
                    'Submit form data to server after generate certificate PDF file has completed.',
                )
            }
        },

        async submitFormData(self, purpose) {
            var files = [self.$screenshot]

            // Certificate
            if (self.certificate != null) {
                files.push(self.certificate)
            }

            // previewForm
            if (self.previewForm != null) {
                files.push(self.previewForm)
            }

            // Member card
            if (self.$memberCard != null) {
                files.push(self.$memberCard)
            }

            // Add IPID and TOB
            if (self.documentFiles != null && self.documentFiles.length) {
                try {
                    const docsFileFormatted = self.documentFiles.map((v) => ({
                        base64: v.fileBase64Content,
                        contentType: v.fileContentType,
                        fileName: v.fileNameWithExtension,
                    }))

                    files.push(...docsFileFormatted)
                } catch (error) {
                    console.error(error)

                    if (process.env.NODE_ENV === 'production') {
                        appInsights.trackException({
                            exception: error,
                            properties: {
                                Function: 'Add IPID and TOB -> files.push(...docsFileFormatted)',
                                Description: 'Add IPID and TOB failed in submitFormData.',
                            },
                        })
                    }
                }
            }

            // Form data
            let applyInput = self.$formData.getCurrentFormData()
            if (applyInput.underwritingQuestions && applyInput.underwritingQuestions.length) {
                applyInput.underwritingQuestions = applyInput.underwritingQuestions.filter((q) => q.isAnswer)
            }

            var emailBody = '<p>Dear Team,</p>'

            switch (purpose) {
                case 'applynow':
                    await self.sendCustomerMailOnApplyNow(self)
                    if (self.isValid) {
                        // underwriting passed
                        emailBody +=
                            '<p>This customer has passed Underwriting but has declined to pay by Credit Card. Please contact the Broker / Customer to arrange payment and proceed with the application.</p>'
                    } else {
                        // underwriting failed
                        emailBody +=
                            '<p>This customer has answered yes to some underwriting questions. Please pass this application on to the Underwriting Team so the application can be reviewed.</p>'
                    }
                    break
                case 'buynow':
                    emailBody += `<p>
							This customer has purchased a Policy. Please:
							<ul>
								<li>Check payment has been received</li>
								<li>Check Know Your Customer / Sanctions</li>
								<li>Then create Policy in Alfie 2</li>
							</ul>
						</p>`
                    break
                default:
                    emailBody = ''
            }

            self.$state.isApplyOrPaymentComplete = true
            storage.setSession(STORAGE.APPLY_PAYMENT_SUCCESS, true)

            // Check whether the sharepoint entry will be a live one or not.
            let liveCustomerServiceSharePointEntry = true
            try {
                liveCustomerServiceSharePointEntry = await baseApi.get(`api/liveCustomerServiceSharePointEntry`)
            } catch (error) {
                if (process.env.NODE_ENV === 'production') {
                    appInsights.trackException({
                        exception: error,
                        properties: {
                            Function: 'liveCustomerServiceSharePointEntry',
                            Description: 'submitFormData calls liveCustomerServiceSharePointEntry',
                        },
                    })
                }
            }

            // Get the insurer company for the selected product.
            let insurerCompany = null
            try {
                insurerCompany = await baseApi.post(`api/getInsurerCompany`, {
                    productSelectedId: self.$formData.product.productId,
                    productSelectedName: self.productName,
                    selectedDate: self.$formData.policyDetails.policyStartDate,
                })
            } catch (error) {
                if (process.env.NODE_ENV === 'production') {
                    appInsights.trackException({
                        exception: error,
                        properties: {
                            Function: 'getInsurerCompany',
                            Description: 'submitFormData calls getInsurerCompany. Call failed for the product.',
                        },
                    })
                }
            }

            let formDataDisplayJson = null

            try {
                formDataDisplayJson = await self.setDataDisplayFile(
                    self,
                    liveCustomerServiceSharePointEntry,
                    insurerCompany,
                )
            } catch (e) {
                console.error('setDataDisplayFile Error: ', e)
                if (process.env.NODE_ENV === 'production') {
                    appInsights.trackException({
                        exception: error,
                        properties: {
                            Function: 'formDataDisplayJson',
                            Description: 'formDataDisplayJson',
                        },
                    })
                }
            }

            if (this.$quote.countryOfResidence.countryID == 86) {
                try {
                    let g_data = {
                        formData: JSON.stringify(self.$formData.getCurrentFormData(), null, '\t'),
                        quote: JSON.stringify(self.$quote, null, '\t'),
                    }

                    const germanyDocument = await baseApi.post('api/pdf/germanyDocumentPdf', g_data)
                    // Download certificate - test ONLY
                    // const blob = await germanyDocument
                    // if (blob && blob.size > 0) {
                    // 	var a = document.createElement('a')
                    // 	a.href = window.URL.createObjectURL(blob)
                    // 	a.setAttribute('download', "_Insurance_Certificate.pdf")
                    // 	a.click()
                    // }
                } catch (e) {
                    console.error('germanyDocument Error: ', e)
                    if (process.env.NODE_ENV === 'production') {
                        appInsights.trackException({
                            exception: error,
                            properties: {
                                Function: 'germanyDocumentPdf',
                                Description: 'germanyDocumentPdf',
                            },
                        })
                    }
                }
            }

            try {
                const underwritingResponsePdf = await baseApi.post(
                    'api/pdf/underwritingResponsePdf',
                    formDataDisplayJson,
                )
                // Download certificate - test ONLY
                // const blob = await underwritingResponsePdf
                // if (blob && blob.size > 0) {
                // 	var a = document.createElement('a')
                // 	a.href = window.URL.createObjectURL(blob)
                // 	a.setAttribute('download', displayFormData.policyNumber+"Underwriting.pdf")
                // 	a.click()
                // }
            } catch (e) {
                console.error('underwritingResponsePdf Error: ', e)
                if (process.env.NODE_ENV === 'production') {
                    appInsights.trackException({
                        exception: error,
                        properties: {
                            Function: 'underwritingResponsePdf',
                            Description: 'underwritingResponsePdf',
                        },
                    })
                }
            }

            // call api apply
            try {
                applyInput.broker = self.$broker ? self.$broker : null

                await baseApi.post('api/apply', {
                    emailSubject: '',
                    emailBody: emailBody,
                    formData: applyInput,
                    files: files,
                    quote: JSON.stringify(self.$quote),
                    purpose: purpose,
                    formDataDisplayJson: formDataDisplayJson,
                })

                // Do not show this modal in case of buy now.
                if (!self.paymentAcceptedOrException) {
                    self.helperTitle = helper.multiLanguageDisplay(self.$root.t('popup.applySuccessMessage'))
                    if (self.isValid) {
                        self.helperContent = helper.multiLanguageDisplay(
                            self.$root.t('popup.applySuccessDeclinePaymentMessage'),
                        )
                    } else {
                        self.helperContent = helper.multiLanguageDisplay(
                            self.$root.t('popup.applySuccessWithYesAnswerMessage'),
                        )
                    }

                    // // Disable all of final screen
                    // self.paymentAcceptedOrException = true

                    document.getElementById('previousBtn').disabled = true
                }

                self.$state.isApplyOrPaymentComplete = true
                storage.setSession(STORAGE.APPLY_PAYMENT_SUCCESS, true)
                document.getElementById('previousBtn').disabled = true

                storage.setSession(STORAGE.APPLY_PAYMENT_SUCCESS, true)
                // Disable the buy now button too.
                self.paymentAcceptedOrException = true
                storage.setSession(STORAGE.PAYMENT_ACCEPT_EXCEPTION, self.paymentAcceptedOrException)

                self.showPaymentStatusModal()

                document.getElementById('previousBtn').disabled = true
            } catch (error) {
                console.error('Apply quote: ', error)
                if (process.env.NODE_ENV === 'production') {
                    appInsights.trackException({
                        exception: error,
                        properties: {
                            Function: 'api/apply',
                            Description: 'Notifies customer service and other tasks.',
                            Purpose: purpose,
                        },
                    })
                }
                self.$state.isApplyOrPaymentComplete = false
                storage.setSession(STORAGE.APPLY_PAYMENT_SUCCESS, false)
                await self.$toast.open({
                    message: helper.multiLanguageDisplay(self.$root.t('notify.cannotApply')),
                    type: 'error',
                })
            }

            self.isApplyLoading = false
            this.keepOpenModal.hide()
        },

        validateForm() {},

        getTotalPrice() {
            this.frequencySelected = quoteService.getTotalPrice(this.summary)
        },

        async sendPaymentExceptionMail(emailSubject, emailBody) {
            if (this.isPaymentSent) {
                return
            }

            this.isPaymentSent = true

            let files = []
            if (this.certificate != null) {
                files.push(this.certificate)
            }

            if (this.previewForm != null) {
                files.push(this.previewForm)
            }

            try {
                await baseApi.post('api/sendPaymentExceptionMail', {
                    emailSubject: emailSubject,
                    emailBody: emailBody,
                    formData: this.$formData.getCurrentFormData(),
                    files: files,
                })

                // this.keepOpenModal.hide()
            } catch (e) {
                console.error('sendPaymentExceptionMail Error: ', e)
            }
        },

        async sendCustomerMail() {
            const self = this
            let files = []

            // Certificate
            if (self.certificate != null) {
                files.push(self.certificate)
            }

            if (self.$memberCard != null) {
                files.push(self.$memberCard)
            }

            // Add IPID and TOB
            if (self.documentFiles != null && self.documentFiles.length) {
                try {
                    const docsFileFormatted = self.documentFiles.map((v) => ({
                        base64: v.fileBase64Content,
                        contentType: v.fileContentType,
                        fileName: v.fileNameWithExtension,
                    }))

                    files.push(...docsFileFormatted)
                } catch (error) {
                    console.error(error)
                    if (process.env.NODE_ENV === 'production') {
                        appInsights.trackException({
                            exception: error,
                            properties: {
                                Function: 'Add IPID and TOB -> files.push(...docsFileFormatted)',
                                Description: 'Add IPID and TOB failed in submitFormData.',
                            },
                        })
                    }
                }
            }

            let policyWordingUrl = ''
            try {
                policyWordingUrl = self.productDocuments[productDocumentType.PolicyWording].fileUrl || ''
            } catch (error) {
                console.error(error)
                if (process.env.NODE_ENV === 'production') {
                    appInsights.trackException({
                        exception: error,
                        properties: {
                            Function: 'policyWordingUrl',
                            Description: 'Gets the policyWordingUrl.',
                            Url: policyWordingUrl,
                        },
                    })
                }
            }

            if (policyWordingUrl) {
                policyWordingUrl = policyWordingUrl.replace(/\s/g, '%20')
            }

            let details = self.$formData.policyHolder.details
            let applyInput = self.$formData.getCurrentFormData()

            // Broker info missing for customer so broker override did not work.
            applyInput.broker = self.$broker ? self.$broker : null

            let emailBody = self.getSendMailCustomerBody(applyInput.broker, details, policyWordingUrl)

            try {
                await baseApi.post('api/sendCustomerMail', {
                    emailSubject: '',
                    emailBody: emailBody,
                    formData: applyInput,
                    files: files,
                })
            } catch (error) {
                console.error(error)
                if (process.env.NODE_ENV === 'production') {
                    appInsights.trackException({
                        exception: error,
                        properties: {
                            Function: 'api/sendCustomerMail',
                            Description: 'Sends an email to the customer.',
                        },
                    })
                }
            }
        },

        async sendCustomerMailOnApplyNow(self) {
            let files = []

            // Add the Apply online form pdf for the customer too.
            if (self.previewForm != null) {
                files.push(self.previewForm)
            }

            // Add IPID and TOB
            if (self.documentFiles != null && self.documentFiles.length) {
                try {
                    const docsFileFormatted = self.documentFiles.map((v) => ({
                        base64: v.fileBase64Content,
                        contentType: v.fileContentType,
                        fileName: v.fileNameWithExtension,
                    }))

                    files.push(...docsFileFormatted)
                } catch (error) {
                    console.error(error)
                    if (process.env.NODE_ENV === 'production') {
                        appInsights.trackException({
                            exception: error,
                            properties: {
                                Function: 'Add IPID and TOB -> files.push(...docsFileFormatted)',
                                Description: 'Add IPID and TOB failed in submitFormData.',
                            },
                        })
                    }
                }
            }

            let details = self.$formData.policyHolder.details
            let applyInput = self.$formData.getCurrentFormData()

            applyInput.broker = self.$broker ? self.$broker : null

            var emailContentKey = 'emailContent.applyNowCustomerBody'
            if (applyInput.broker) {
                if (applyInput.broker.brokerEmailOverride) {
                    emailContentKey = 'emailContent.applyNowCustomerBodyForBrokerOverride'
                } else {
                    emailContentKey = 'emailContent.applyNowCustomerBodyForBrokerWithNoOverride'
                }
            }

            let emailBody = this.$t(emailContentKey, {
                customerName: `${details.forename} ${details.surname}`,
            })

            try {
                await baseApi.post('api/sendCustomerMail', {
                    emailSubject: '',
                    emailBody: emailBody,
                    formData: applyInput,
                    files: files,
                })
            } catch (error) {
                //console.error(JSON.stringify(error))
                if (process.env.NODE_ENV === 'production') {
                    appInsights.trackException({
                        exception: error,
                        properties: {
                            Function: 'api/sendCustomerMail',
                            Description: 'Sends an email to the customer on apply now.',
                        },
                    })
                }
            }
        },

        async downloadFile(fileName, blob) {
            let a = document.createElement('a')
            a.href = window.URL.createObjectURL(blob)
            a.setAttribute('download', fileName)
            a.click()
        },

        getSendMailCustomerBody(broker, details, policyWordingUrl) {
            var emailContentKey = 'emailContent.customerBody'
            if (broker) {
                if (broker.brokerEmailOverride) {
                    emailContentKey = 'emailContent.customerBodyForBrokerOverride'
                } else {
                    emailContentKey = 'emailContent.customerBodyForBrokerWithNoOverride'
                }
            }

            return this.$t(emailContentKey, {
                customerName: `${details.forename} ${details.surname}`,
                policyWordingUrl: policyWordingUrl,
            })
        },

        getFirstInvoiceAmount() {
            if (this.summary.frequencySelected.invoices.length == 0) {
                return 0
            }

            return this.summary.frequencySelected.invoices[0].amount
        },

        getSecondInvoiceAmount() {
            if (this.summary.frequencySelected.invoices.length <= 1) {
                return 0
            }

            return this.summary.frequencySelected.invoices[1].amount
        },        
    },
}
</script>

<style lang="scss" scoped>
.applyButton {
    &:disabled {
        background-color: grey;
        border: grey;
    }
}
.summary-item {
    @media (max-width: 750px) {
        width: 100% !important;
        flex-wrap: wrap;
        padding-left: 0px !important;
        margin-bottom: 20px;

        &:last-child {
            margin-bottom: 0px;
        }
    }

    &__title {
        font-size: 16px;
        color: #828282;
        &__end {
            margin-bottom: 0.5em !important;
        }
    }

    &__description {
        font-size: 1.2em;
        color: #333333;
        font-weight: 500;
    }

    &-control-section {
        margin-bottom: 2rem;
    }
}

.summary-checkbox {
    margin-bottom: 1.5em;
    &__title {
        color: #1076bc;
        font-weight: 500;
        font-size: 20px;
        margin-bottom: 0.25em;
    }

    &__checkbox {
        display: flex;
        margin-left: 3px;
        &-tick {
            transform: scale(1.3);
            height: 24px;
        }

        &-label {
            font-size: 16px;
            text-align: left;
            padding-left: 10px;
        }
    }
}

.price-table {
    &__title {
        padding-bottom: 0px;
        font-size: 1.5rem;
    }
    &__item {
        padding: 0.5em 0;
        // display: flex;
        align-items: center;
        &-value {
            // font-weight: bold;
            font-size: 1.2rem;
        }
    }
}

.summary {
    display: flex;

    @media (max-width: 800px) {
        flex-wrap: wrap !important;
    }
}

.right-panel {
    @media (min-width: 800px) {
        padding-right: 1.5rem !important;
    }
}
</style>
